import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { router } from './router'
import * as filters from './filters' // global filters
import $ from 'jquery'
import infiniteScroll from 'vue-infinite-scroll'
// import FastClick from 'fastclick';
import Cookies from 'js-cookie'
import CONFIG from './config/config'
import Vconsole from 'vconsole'
import Mint from 'mint-ui'
import dsBridge from 'dsbridge'
import 'mint-ui/lib/style.css'
import utils from '@/utils/utils'
import '@/utils/vee-validate'
import i18n from './languages' // internationalization
// import Video from 'video.js'
// import 'video.js/dist/video-js.css'
import components from './components'

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import VueFullPage from 'vue-fullpage.js'
import './style/fullpage.css'

import VueLazyload from 'vue-lazyload'
// Vue.prototype.$video = Video
Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   preLoad: 1.2,
//   // error: 'dist/error.png',
//   // loading: 'dist/loading.gif',
//   attempt: 1
// })
Vue.use(VueFullPage)
// Vue.use(vueAwesomeSwiper)
Vue.use(infiniteScroll)
Vue.use(Mint)

if (process.env.NODE_ENV !== 'production') {
  new Vconsole()
}

// 移动UI库
import Vant from 'vant'
import 'vant/lib/index.less'
Vue.use(Vant)

// 动画库
import lottie from 'vue-lottie'
Vue.use(lottie)
Vue.component('Lottie', lottie)

Object.keys(components).forEach((key) => { // components组件全局引用
  Vue.component(key, components[key])
})

const BrowerLogger = require('alife-logger') // 阿里云监管 -shber
// BrowserLogger.singleton(conf) conf传入config配置
const __bl = BrowerLogger.singleton({
  pid: CONFIG.browerLoggerKey,
  imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?' // 设定日志上传地址,新加坡部署可选`https://arms-retcode-sg.aliyuncs.com/r.png?`
  // 其他config配置
})

const handler = (e) => {
  e.preventDefault()
}
Vue.directive('roll', {
  componentUpdated(el, binding) {
    if (binding.value instanceof Array) {
      const visible = binding.value.some(e => e) // 当视图所有控制弹层的变量存在一个是true，即可阻止touchmove事件
      if (visible) {
        document.getElementsByTagName('body')[0].addEventListener('touchmove', handler, { passive: false })
      } else {
        document.getElementsByTagName('body')[0].removeEventListener('touchmove', handler, { passive: false })
      }
    } else if (typeof binding.value === 'boolean') {
      if (binding.value) {
        document.getElementsByTagName('body')[0].addEventListener('touchmove', handler, { passive: false })
      } else {
        document.getElementsByTagName('body')[0].removeEventListener('touchmove', handler, { passive: false })
      }
    }
  }
})

Vue.config.productionTip = false
// FastClick.attach(document.body);
const app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
})

const miniToken = utils.getQueryVariable('token') // 小程序的token
if (miniToken) {
  Cookies.set('Mini-Token', miniToken)
  sessionStorage.setItem('Mini-Token', miniToken)
}
if (utils.isGteatChefbrowser()) {
  utils.getEnv().then(res => {
    Cookies.set('env', res)
  })
  utils.getAuth().then(res => {
    res = JSON.parse(res)
    if (res.success === 'yes') {
      Cookies.set('token', JSON.stringify(res))
      sessionStorage.setItem('token', JSON.stringify(res))
    }
    app.$mount('#app')
  })
  if (typeof (dsBridge.call('getAuth', function(result) {})) === 'undefined') {
    app.$mount('#app')
  }
} else {
  app.$mount('#app')
}

